"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3370],{

/***/ 13370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ VideoPlayerAudiDescription; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(7980);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(33227);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/createClass.js
var createClass = __webpack_require__(88361);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/inherits.js
var inherits = __webpack_require__(85971);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(52715);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(91193);
var getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.bind.js
var es_function_bind = __webpack_require__(24812);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./persistence/localStorage.js
var localStorage = __webpack_require__(77005);
// EXTERNAL MODULE: ./adapters/helpers/Constants.js
var Constants = __webpack_require__(24036);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/VideoPlayer/AudioSwitch.js



function AudioSwitch(_ref) {
  var idValue = _ref.idValue,
      audioSrc = _ref.audioSrc,
      audioFileType = _ref.audioFileType;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("audio", {
    id: idValue,
    preload: "auto",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      src: Constants/* VideoPlayerConstants.domainHttp */.K1.domainHttp + audioSrc,
      type: audioFileType
    })
  });
}
// EXTERNAL MODULE: ./adapters/helpers/VideoPlayerFactory.js
var VideoPlayerFactory = __webpack_require__(48853);
// EXTERNAL MODULE: ./node_modules/cloudinary-core/cloudinary-core.js
var cloudinary_core = __webpack_require__(14934);
// EXTERNAL MODULE: ./adapters/helpers/Utils.js
var Utils = __webpack_require__(8996);
;// CONCATENATED MODULE: ./components/VideoPlayer/VideoPlayerAudiDescription.js













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = getPrototypeOf_default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf_default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn_default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }











var VideoPlayerAudioDescription = /*#__PURE__*/function (_Component) {
  inherits_default()(VideoPlayerAudioDescription, _Component);

  var _super = _createSuper(VideoPlayerAudioDescription);

  function VideoPlayerAudioDescription(props) {
    var _this;

    classCallCheck_default()(this, VideoPlayerAudioDescription);

    _this = _super.call(this, props);
    _this.videoRef = /*#__PURE__*/react.createRef();
    _this.videoPlayer = null;
    _this.video = props.video;
    _this.state = {
      video: null
    };
    return _this;
  }

  createClass_default()(VideoPlayerAudioDescription, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      __webpack_require__(14060);

      var soundPlayed = false;

      if (this.videoIsDefined()) {
        var videoPlayerFactory = new VideoPlayerFactory/* default */.Z(this.videoRef, this.video);
        this.createVideoPlayer(videoPlayerFactory);
      }

      var cld = new cloudinary_core.Cloudinary({
        cloud_name: "OralB"
      });
      var videoPlayer = cld.videoPlayer("player", {
        muted: false,
        controls: true
      });

      function removeSoundFromLocalStorage() {
        (0,localStorage/* localStorageRemoveItem */.q)(Constants/* VideoPlayerConstants.firstAudio */.K1.firstAudio);
        (0,localStorage/* localStorageRemoveItem */.q)(Constants/* VideoPlayerConstants.secondAudio */.K1.secondAudio);
      }

      var videoFile = videoPlayer.videojs;
      var ratioVolume = Constants/* VideoPlayerConstants.videoRatioVolume */.K1.videoRatioVolume;
      var firstAudiofile = (0,Utils/* documentGetElementById */.HJ)(Constants/* VideoPlayerConstants.firstAudioFileId */.K1.firstAudioFileId);
      var secondAudiofile = (0,Utils/* documentGetElementById */.HJ)(Constants/* VideoPlayerConstants.secondAudioFileId */.K1.secondAudioFileId);
      var audioDescriptionIcon = (0,Utils/* documentGetElementByClassName */.FP)(Constants/* VideoPlayerConstants.audioDescriptionClassName */.K1.audioDescriptionClassName);
      removeSoundFromLocalStorage();
      var soundTrack = new Audio();
      soundTrack.autoplay = true;
      soundTrack.src = '';
      soundTrack.volume = Math.min(videoFile.volume() + ratioVolume, 1);

      function playSound() {
        var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        soundTrack.src = src;
        soundTrack.id = id;
        soundTrack.currentTime = videoFile.currentTime();
        soundTrack.play();
      }

      function endSound() {
        soundPlayed = false;
        soundTrack.src = null;
        soundTrack.pause();
      }

      function isFirstAudio() {
        return soundTrack.id === Constants/* VideoPlayerConstants.firstAudioFileId */.K1.firstAudioFileId;
      }

      function pauseSound() {
        var firstAudioActive = isFirstAudio();
        soundTrack.pause();
        (0,localStorage/* localStorageSetItem */.A6)(firstAudioActive ? Constants/* VideoPlayerConstants.firstAudio */.K1.firstAudio : Constants/* VideoPlayerConstants.secondAudio */.K1.secondAudio, Constants/* ContentConstants.pause */.Kd.pause);
        (0,localStorage/* localStorageRemoveItem */.q)(firstAudioActive ? Constants/* VideoPlayerConstants.secondAudio */.K1.secondAudio : Constants/* VideoPlayerConstants.firstAudio */.K1.firstAudio);
      }

      if (firstAudiofile) {
        var _videoPlayer$videojs, _videoPlayer$videojs$;

        var ADButton = videoPlayer == null ? void 0 : (_videoPlayer$videojs = videoPlayer.videojs) == null ? void 0 : (_videoPlayer$videojs$ = _videoPlayer$videojs.controlBar) == null ? void 0 : _videoPlayer$videojs$.addChild('button');
        ADButton.el_.classList.add(Constants/* VideoPlayerConstants.audioDescriptionClassName */.K1.audioDescriptionClassName);

        if (audioDescriptionIcon && audioDescriptionIcon.length > 0) {
          audioDescriptionIcon[0].style.opacity = Constants/* VideoPlayerConstants.descriptionButtonLowOpacity */.K1.descriptionButtonLowOpacity;
        }

        firstAudiofile.volume = ratioVolume;

        var ADButtonEvent = function ADButtonEvent() {
          if (videoFile.paused()) return;

          if (isFirstAudio()) {
            secondAudiofile.volume = Math.min(videoFile.volume() + ratioVolume, 1);

            if (audioDescriptionIcon && audioDescriptionIcon.length > 0) {
              audioDescriptionIcon[0].style.opacity = Constants/* VideoPlayerConstants.descriptionButtonHighOpacity */.K1.descriptionButtonHighOpacity;
            }

            playSound(secondAudiofile.children[0].src, secondAudiofile.id);
          } else {
            firstAudiofile.volume = Math.min(videoFile.volume() + ratioVolume, 1);
            playSound(firstAudiofile.children[0].src, firstAudiofile.id);

            if (audioDescriptionIcon && audioDescriptionIcon.length > 0) {
              audioDescriptionIcon[0].style.opacity = Constants/* VideoPlayerConstants.descriptionButtonLowOpacity */.K1.descriptionButtonLowOpacity;
            }
          }
        };

        ADButton.on('click', function (e) {
          ADButtonEvent();
        });
        ADButton.on('touchstart', function (e) {
          ADButtonEvent();
        });
        ADButton.on('touchend', function (e) {
          e.preventDefault();
        });
        videoFile.on('playing', function () {
          if ((0,localStorage/* localStorageGetItem */.GQ)(Constants/* VideoPlayerConstants.firstAudio */.K1.firstAudio) === Constants/* ContentConstants.pause */.Kd.pause || (0,localStorage/* localStorageGetItem */.GQ)(Constants/* VideoPlayerConstants.secondAudio */.K1.secondAudio) == Constants/* ContentConstants.pause */.Kd.pause) {
            (0,localStorage/* localStorageGetItem */.GQ)(Constants/* VideoPlayerConstants.firstAudio */.K1.firstAudio) === Constants/* ContentConstants.pause */.Kd.pause ? playSound(firstAudiofile.children[0].src, firstAudiofile.id) : playSound(secondAudiofile.children[0].src, secondAudiofile.id);
            removeSoundFromLocalStorage();
            return;
          }

          if (soundPlayed) return;
          soundPlayed = true;
          playSound(firstAudiofile.children[0].src, firstAudiofile.id);
        });
        videoFile.on('pause', function () {
          pauseSound();
        });
        videoFile.on('ended', function () {
          videoFile.pause();
          endSound();
        });
        videoFile.on('volumechange', function () {
          soundTrack.volume = videoFile.volume();
          soundTrack.muted = false;

          if (videoFile.muted()) {
            soundTrack.muted = true;
          }
        });
        videoFile.on('seeking', function () {
          if (soundTrack.readyState >= 4) {
            if (Math.ceil(soundTrack.currentTime) != Math.ceil(this.currentTime())) {
              soundTrack.currentTime = this.currentTime();
            }
          }
        });
      }
    }
  }, {
    key: "createVideoPlayer",
    value: function createVideoPlayer(videoPlayerFactory) {
      var _this$props$video,
          _this$props$video$sub,
          _this$props$video2,
          _this$props$video2$ca,
          _this$props$video2$ca2,
          _this$props$video3,
          _this$props$video3$ca,
          _this$props$video3$ca2,
          _this$props$video4,
          _this$props$video4$ca,
          _this$props$video4$ca2,
          _this$props$video5,
          _this$props$video5$ca,
          _this$props$video5$ca2,
          _this$props$video6,
          _this2 = this;

      var subTitles = (_this$props$video = this.props.video) == null ? void 0 : (_this$props$video$sub = _this$props$video.subTitles) == null ? void 0 : _this$props$video$sub.map(function (subtitle) {
        var _subtitle$fields, _subtitle$fields2, _subtitle$fields3;

        return {
          label: subtitle == null ? void 0 : (_subtitle$fields = subtitle.fields) == null ? void 0 : _subtitle$fields.label,
          language: subtitle == null ? void 0 : (_subtitle$fields2 = subtitle.fields) == null ? void 0 : _subtitle$fields2.language,
          url: subtitle == null ? void 0 : (_subtitle$fields3 = subtitle.fields) == null ? void 0 : _subtitle$fields3.url
        };
      });
      var textTracks = {
        captions: {
          label: (_this$props$video2 = this.props.video) == null ? void 0 : (_this$props$video2$ca = _this$props$video2.captions) == null ? void 0 : (_this$props$video2$ca2 = _this$props$video2$ca.fields) == null ? void 0 : _this$props$video2$ca2.label,
          "default": (_this$props$video3 = this.props.video) == null ? void 0 : (_this$props$video3$ca = _this$props$video3.captions) == null ? void 0 : (_this$props$video3$ca2 = _this$props$video3$ca.fields) == null ? void 0 : _this$props$video3$ca2["default"],
          language: (_this$props$video4 = this.props.video) == null ? void 0 : (_this$props$video4$ca = _this$props$video4.captions) == null ? void 0 : (_this$props$video4$ca2 = _this$props$video4$ca.fields) == null ? void 0 : _this$props$video4$ca2.language,
          url: (_this$props$video5 = this.props.video) == null ? void 0 : (_this$props$video5$ca = _this$props$video5.captions) == null ? void 0 : (_this$props$video5$ca2 = _this$props$video5$ca.fields) == null ? void 0 : _this$props$video5$ca2.url
        },
        subtitles: subTitles && toConsumableArray_default()(subTitles)
      };
      textTracks = subTitles && ((_this$props$video6 = this.props.video) == null ? void 0 : _this$props$video6.captions) && textTracks;
      var source = textTracks ? {
        sourceTypes: ["webm", "mp4", "hls", "ogg"],
        textTracks: textTracks
      } : {
        sourceTypes: ["webm", "mp4", "hls", "ogg"]
      };
      videoPlayerFactory.create().then(function (_ref) {
        var _this2$video, _this2$video$asset, _this2$video$asset$fi, _this2$video$asset$fi2;

        var videoPlayer = _ref.videoPlayer,
            transformation = _ref.transformation;
        var video = videoPlayer.Cloudinary["new"]({
          secure: true
        }).videoPlayer(_this2.videoRef.current, {
          loop: _this2.video.loop,
          fontFace: "inherit",
          fluid: true,
          preload: _this2.video.preload ? 'auto' : 'none',
          controls: _this2.video.controls,
          autoplayMode: _this2.video.autoplay,
          playsinline: _this2.video.playsInline
        }).transformation(transformation).source((_this2$video = _this2.video) == null ? void 0 : (_this2$video$asset = _this2$video.asset) == null ? void 0 : (_this2$video$asset$fi = _this2$video$asset.fields) == null ? void 0 : (_this2$video$asset$fi2 = _this2$video$asset$fi.file) == null ? void 0 : _this2$video$asset$fi2.url, source);

        _this2.setState({
          video: video
        });

        _this2.videoPlayer = video;

        _this2.videoPlayer.on("canplay", _this2.onVideoLoaded.bind(_this2));

        _this2.videoPlayer.on("play", _this2.onVideoPlay.bind(_this2));

        _this2.videoPlayer.on("pause", _this2.onVideoPause.bind(_this2));

        _this2.videoPlayer.on("mute", _this2.onVideoMuted.bind(_this2));

        _this2.videoPlayer.on("unmute", _this2.onVideoUnMuted.bind(_this2));

        _this2.videoPlayer.on("fullscreenchange", _this2.onVideoFullScreen.bind(_this2));
      })["catch"](function (error) {
        console.error(error);
      });
    }
  }, {
    key: "videoIsDefined",
    value: function videoIsDefined() {
      var _this$video, _this$video$asset, _this$video$asset$fie, _this$video$asset$fie2;

      return this.video && ((_this$video = this.video) == null ? void 0 : (_this$video$asset = _this$video.asset) == null ? void 0 : (_this$video$asset$fie = _this$video$asset.fields) == null ? void 0 : (_this$video$asset$fie2 = _this$video$asset$fie.file) == null ? void 0 : _this$video$asset$fie2.url);
    }
  }, {
    key: "renderTranscript",
    value: function renderTranscript() {
      var _this$video2;

      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "video-player-transcript visuallyhidden",
        children: (_this$video2 = this.video) == null ? void 0 : _this$video2.transcript
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$video7, _this$props$video7$ca, _this$props$video8, _subtitlesVideo$, _this$props$video9, _this$props$video9$ke, _this$props$video9$ke2, _this$props$video9$ke3, _this$props$video9$ke4, _this$props$video10, _this$props$video10$k, _this$props$video10$k2, _this$props$video10$k3, _this$props$video10$k4, _this$props$video11, _this$props$video11$k, _this$props$video11$k2, _this$props$video11$k3, _this$props$video11$k4, _this$props$video11$k5, _this$props$video12, _this$props$video13, _this$props$video14, _this$props$video14$v, _this$props$video14$v2, _this$props$video15, _this$props$video15$v, _this$props$video15$v2, _this$props$video16, _this$props$video16$a, _this$props$video16$a2, _this$props$video16$a3, _this$props$video17, _this$video3, _this$video3$asset, _this$video3$asset$fi, _this$video3$asset$fi2, _this$video4, _this$video4$videoAud, _this$video4$videoAud2, _this$video4$videoAud3, _this$video5, _this$video5$videoAud, _this$video5$videoAud2, _this$video5$videoAud3, _this$video6, _this$video6$videoAud, _this$video6$videoAud2, _this$video6$videoAud3, _this$video7, _this$video7$videoAud, _this$video7$videoAud2, _this$video7$videoAud3;

      var captionsTrack = (_this$props$video7 = this.props.video) == null ? void 0 : (_this$props$video7$ca = _this$props$video7.captions) == null ? void 0 : _this$props$video7$ca.fields;
      var subtitlesVideo = (_this$props$video8 = this.props.video) == null ? void 0 : _this$props$video8.subTitles;
      var subTitleTrack = (subtitlesVideo == null ? void 0 : (_subtitlesVideo$ = subtitlesVideo[0]) == null ? void 0 : _subtitlesVideo$.fields) || null;
      var name = (_this$props$video9 = this.props.video) == null ? void 0 : (_this$props$video9$ke = _this$props$video9.keyframe) == null ? void 0 : (_this$props$video9$ke2 = _this$props$video9$ke.fields) == null ? void 0 : (_this$props$video9$ke3 = _this$props$video9$ke2.asset) == null ? void 0 : (_this$props$video9$ke4 = _this$props$video9$ke3.fields) == null ? void 0 : _this$props$video9$ke4.title;
      var description = (_this$props$video10 = this.props.video) == null ? void 0 : (_this$props$video10$k = _this$props$video10.keyframe) == null ? void 0 : (_this$props$video10$k2 = _this$props$video10$k.fields) == null ? void 0 : (_this$props$video10$k3 = _this$props$video10$k2.asset) == null ? void 0 : (_this$props$video10$k4 = _this$props$video10$k3.fields) == null ? void 0 : _this$props$video10$k4.description;
      var thumbnailurl = (_this$props$video11 = this.props.video) == null ? void 0 : (_this$props$video11$k = _this$props$video11.keyframe) == null ? void 0 : (_this$props$video11$k2 = _this$props$video11$k.fields) == null ? void 0 : (_this$props$video11$k3 = _this$props$video11$k2.asset) == null ? void 0 : (_this$props$video11$k4 = _this$props$video11$k3.fields) == null ? void 0 : (_this$props$video11$k5 = _this$props$video11$k4.file) == null ? void 0 : _this$props$video11$k5.url;
      var UploadDate = (_this$props$video12 = this.props.video) == null ? void 0 : _this$props$video12.uploadDate;
      var duration = (_this$props$video13 = this.props.video) == null ? void 0 : _this$props$video13.duration;
      var width = (_this$props$video14 = this.props.video) == null ? void 0 : (_this$props$video14$v = _this$props$video14.videoSettings) == null ? void 0 : (_this$props$video14$v2 = _this$props$video14$v.fields) == null ? void 0 : _this$props$video14$v2.width;
      var height = (_this$props$video15 = this.props.video) == null ? void 0 : (_this$props$video15$v = _this$props$video15.videoSettings) == null ? void 0 : (_this$props$video15$v2 = _this$props$video15$v.fields) == null ? void 0 : _this$props$video15$v2.height;
      var contenturl = (_this$props$video16 = this.props.video) == null ? void 0 : (_this$props$video16$a = _this$props$video16.asset) == null ? void 0 : (_this$props$video16$a2 = _this$props$video16$a.fields) == null ? void 0 : (_this$props$video16$a3 = _this$props$video16$a2.file) == null ? void 0 : _this$props$video16$a3.url;
      var ariaLabel = (_this$props$video17 = this.props.video) == null ? void 0 : _this$props$video17.ariaLabel;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "ob-video-player videoAudioDescription",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("video", {
          muted: true,
          playsInline: true,
          ref: this.videoRef,
          id: "player",
          "aria-label": ariaLabel,
          crossOrigin: "anonymous",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
            src: 'https:' + ((_this$video3 = this.video) == null ? void 0 : (_this$video3$asset = _this$video3.asset) == null ? void 0 : (_this$video3$asset$fi = _this$video3$asset.fields) == null ? void 0 : (_this$video3$asset$fi2 = _this$video3$asset$fi.file) == null ? void 0 : _this$video3$asset$fi2.url),
            type: "video/mp4"
          }), captionsTrack && /*#__PURE__*/(0,jsx_runtime.jsx)("track", {
            label: captionsTrack == null ? void 0 : captionsTrack.label,
            kind: "captions",
            srcLang: captionsTrack == null ? void 0 : captionsTrack.language,
            src: captionsTrack == null ? void 0 : captionsTrack.url,
            "default": captionsTrack == null ? void 0 : captionsTrack["default"]
          }), subTitleTrack && /*#__PURE__*/(0,jsx_runtime.jsx)("track", {
            label: subTitleTrack == null ? void 0 : subTitleTrack.label,
            kind: "subtitles",
            srcLang: subTitleTrack == null ? void 0 : subTitleTrack.language,
            src: subTitleTrack == null ? void 0 : subTitleTrack.url,
            "default": subTitleTrack == null ? void 0 : subTitleTrack["default"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AudioSwitch, {
          idValue: Constants/* VideoPlayerConstants.firstAudioFileId */.K1.firstAudioFileId,
          audioSrc: (_this$video4 = this.video) == null ? void 0 : (_this$video4$videoAud = _this$video4.videoAudio) == null ? void 0 : (_this$video4$videoAud2 = _this$video4$videoAud.fields) == null ? void 0 : (_this$video4$videoAud3 = _this$video4$videoAud2.file) == null ? void 0 : _this$video4$videoAud3.url,
          audioFileType: Constants/* FileTypeConstants */.ZJ[(0,Utils/* getFileExtensions */.Tq)((_this$video5 = this.video) == null ? void 0 : (_this$video5$videoAud = _this$video5.videoAudio) == null ? void 0 : (_this$video5$videoAud2 = _this$video5$videoAud.fields) == null ? void 0 : (_this$video5$videoAud3 = _this$video5$videoAud2.file) == null ? void 0 : _this$video5$videoAud3.url)] || 'audio/mp4'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AudioSwitch, {
          idValue: Constants/* VideoPlayerConstants.secondAudioFileId */.K1.secondAudioFileId,
          audioSrc: (_this$video6 = this.video) == null ? void 0 : (_this$video6$videoAud = _this$video6.videoAudioDescription) == null ? void 0 : (_this$video6$videoAud2 = _this$video6$videoAud.fields) == null ? void 0 : (_this$video6$videoAud3 = _this$video6$videoAud2.file) == null ? void 0 : _this$video6$videoAud3.url,
          audioFileType: Constants/* FileTypeConstants */.ZJ[(0,Utils/* getFileExtensions */.Tq)((_this$video7 = this.video) == null ? void 0 : (_this$video7$videoAud = _this$video7.videoAudioDescription) == null ? void 0 : (_this$video7$videoAud2 = _this$video7$videoAud.fields) == null ? void 0 : (_this$video7$videoAud3 = _this$video7$videoAud2.file) == null ? void 0 : _this$video7$videoAud3.url)] || 'audio/mp4'
        }), this.renderTranscript()]
      });
    }
  }]);

  return VideoPlayerAudioDescription;
}(react.Component);

/* harmony default export */ var VideoPlayerAudiDescription = (VideoPlayerAudioDescription);

/***/ }),

/***/ 77005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A6": function() { return /* binding */ localStorageSetItem; },
/* harmony export */   "GQ": function() { return /* binding */ localStorageGetItem; },
/* harmony export */   "dA": function() { return /* binding */ LOCAL_STORAGE_KEYS; },
/* harmony export */   "q": function() { return /* binding */ localStorageRemoveItem; }
/* harmony export */ });
var LOCAL_STORAGE_KEYS = {
  RECENTLY_VIEWED_PRODUCTS: 'RECENTLY_VIEWED_PRODUCTS'
};
function localStorageRemoveItem(item) {
  return localStorage.removeItem(item);
}
function localStorageGetItem(item) {
  return localStorage.getItem(item);
}
function localStorageSetItem(item, itemType) {
  return localStorage.setItem(item, itemType);
}


/***/ })

}]);